import { render } from "./InstructionsTab.vue?vue&type=template&id=4a4e3007&scoped=true"
import script from "./InstructionsTab.vue?vue&type=script&lang=js"
export * from "./InstructionsTab.vue?vue&type=script&lang=js"

import "./InstructionsTab.vue?vue&type=style&index=0&id=4a4e3007&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4e3007"]])

export default __exports__